/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CostTypeDto } from '../../models/cost-type-dto';
import { CreateCostTypeRequest } from '../../models/create-cost-type-request';

export interface CreateCostType$Params {
      body: CreateCostTypeRequest
}

export function createCostType(http: HttpClient, rootUrl: string, params: CreateCostType$Params, context?: HttpContext): Observable<StrictHttpResponse<CostTypeDto>> {
  const rb = new RequestBuilder(rootUrl, createCostType.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CostTypeDto>;
    })
  );
}

createCostType.PATH = '/v0/costTypes';
